import { render, staticRenderFns } from "./deviceInfo.vue?vue&type=template&id=012c4814&scoped=true"
import script from "./deviceInfo.vue?vue&type=script&lang=js"
export * from "./deviceInfo.vue?vue&type=script&lang=js"
import style0 from "./deviceInfo.vue?vue&type=style&index=0&id=012c4814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012c4814",
  null
  
)

export default component.exports